import { render, staticRenderFns } from "./CouponUpdate.vue?vue&type=template&id=3164cab0&scoped=true&"
import script from "./CouponUpdate.vue?vue&type=script&lang=js&"
export * from "./CouponUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3164cab0",
  null
  
)

export default component.exports